<!--图片分享-->
<template>
  <Layer name="SharePost" mask-direction="Middle" :visible="visible">
    <div
      class="dlrLayer-middle sharePost"
      v-stat:show="{ action: statInfo.show }"
    >
      <!--长的用sharePost-box-long  短的用sharePost-box-short-->
      <div
        class="sharePost-box"
        :class="type === 1 ? 'sharePost-box-long' : 'sharePost-box-short'"
      >
        <div class="sharePost-top">
          <div class="sharePost-pic">
            <img
              v-if="shareImgUrl"
              :src="shareImgUrl"
              @load="loadComplete"
              alt
            />
          </div>
        </div>
        <div class="sharePost-bottom">
          <a
            class="sharePost-close"
            href="javascript:void(0);"
            @click="close"
          ></a>
          <a
            class="sharePost-save"
            href="javascript:void(0);"
            v-stat:click="{ action: statInfo.click }"
            @click="saveAndShare"
            >保存并分享</a
          >
        </div>
      </div>
      <div class="dlrLayer-mask"></div>
    </div>
  </Layer>
</template>
<script>
import { mapGetters } from 'vuex';
import Layer from '../Layer.vue';
import shareManager from '../../services/share.manager';
import layerManager from '../../services/layer.manager';
import activityService from '../../services/dealerAct.service';
import util from '../../utils/util';
import shareApi from '../../apis/share.api';
export default {
  name: 'SharePost',
  props: {
    options: {
      props: {
        type: Object,
        default: function () {
          return {};
        }
      }
    }
  },
  components: {
    Layer
  },
  computed: {
    ...mapGetters({
      baseInfo: 'baseInfo'
    }),
    dealerId () {
      return this.baseInfo.dealerId;
    }
  },
  data () {
    return {
      shareImgUrl: '',
      shareImgBinary: '',
      visible: true,
      type: 1,
      statInfo: {
        show: '',
        click: ''
      }
    };
  },
  methods: {
    show (options) {
      if (!util.browser.isApp) {
        return;
      }
      console.log(options);
      const self = this;
      self.shareImgUrl = '';
      self.shareImgBinary = '';
      this.getStatInfo(options);
      this.getSharePoster(options);
      document.getElementsByTagName('body')[0].className = 'body_fixed';
    },
    close () {
      this.visible = false;
      document.getElementsByTagName('body')[0].className = '';
    },
    getSharePoster (options) {
      const self = this;
      let params = {
        dealerId: self.dealerId,
        type: options.type
      };
      this.type = options.type;
      if (options.type === 2) {
        params.activityType = options.activityType;
        params.activityId = options.activityId;
        params.giftId = options.giftId;
        params.number = options.number;
      }
      layerManager.openToast({ propsData: { message: '加载中', iconCls: 'iconLoading' } });
      let sharePosterPromise = null;
      if (options.sharePosterType === '3DCar') {
        params.type = 1;
        params.seriesId = options.seriesId;
        params.url = options.url;
        /**
         * * 获取展厅分享海报
         * */
        sharePosterPromise = shareApi.get3DCarSharePoster(params.dealerId, params.type, params.seriesId, params.url);
      } else {
        /**
         * 获取展厅分享海报
         */
        sharePosterPromise = shareApi.getHallSharePoster(
          params.dealerId,
          params.type,
          params.activityType,
          params.activityId,
          params.giftId,
          params.number
        );
      }
      sharePosterPromise.then(res => {
        console.log(res);
        if (res.returncode === 0) {
          self.shareImgUrl = res.result.url;
          self.shareImgBinary = res.result.imgBase64;
        } else {
          self.shareError();
        }
      }).catch(err => {
        console.log(err);
        self.shareError();
      });
    },
    shareError () {
      layerManager.openToast({ propsData: { message: '网络异常，请重新分享~', iconCls: 'iconError' } });
      setTimeout(() => {
        layerManager.closeToast();
      }, 1000);
    },
    saveAndShare () {
      const self = this;
      shareManager.saveShareImage({ imgUrl: self.shareImgUrl, callback: self.showImageSharePanel.call(self) });
    },
    showImageSharePanel () {
      const self = this;
      shareManager.showShare({ isNative: true, platform: 'all', binaryimage: self.shareImgBinary, shareCallback: self.close.bind(self) });
    },
    getStatInfo (options) {
      let activitytype = 0;
      if (options.type === 2) {
        activitytype = options.activityType;
      }
      const stat = activityService.getSharePosterStatInfo('saveShare', activitytype);
      this.statInfo = stat;
    },
    loadComplete () {
      layerManager.closeToast();
    }
  },
  watch: {
    options: {
      handler: function (newVal) {
        this.show(newVal);
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
<style lang="scss">
.sharePost {
  width: 100%;
  height: 100%;

  &-box {
    width: 100%;
  }
  &-box-long {
    height: 100%;
    z-index: 11;
    position: relative;
  }
  &-box-short {
    position: absolute;
    z-index: 11;
    top: 50%;
    width: 100%;
    transform: translateY(-50%);
    .sharePost-top {
      position: static;
      height: auto;
    }

    .sharePost-pic {
      padding-bottom: 0;
    }
    .sharePost-bottom {
      position: static;
      bottom: auto;
      margin-top: ptrd(40px);
      height: ptrd(80px);
      line-height: ptrd(80px);
      background: rgba(0, 0, 0, 0);
    }
  }

  &-top {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 94%;
    left: 0;
  }
  &-pic {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
    text-align: center;
    &::-webkit-scrollbar {
      display: none;
    }
    img {
      //width: ptrd(600px);
      width: 80%;
    }
  }
  &-bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
    left: 0;
    height: ptrd(220px);
    line-height: ptrd(220px);
    font-size: 0;
    text-align: center;
    background-image: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 5%,
      rgba(0, 0, 0, 0.6) 50%
    );
    z-index: 12;
    a {
      display: inline-block;
      vertical-align: middle;
      & + a {
        margin-left: ptrd(40px);
      }
    }
  }
  &-close {
    width: ptrd(56);
    height: ptrd(56);
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAAWlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////9ZMre9AAAAHXRSTlMA60bkynUVDNaEONyYjGNUKx2pnz6yuPVaJEtpwWKFO5IAAAKySURBVGje7JXJlqwgEEQTAcXZcmztvv//m29XnK5qxFKX766cTgZkZKD85yYeY5MPs3Gl1qUz85A340PuIk3yqeSNcsqTVC6TbZUDQJmpyu1303zbvJqMAsBVWyZXWK0BKHubrNkv3TWxfQlg7Cpn6WoNuDpJQ72rHaDr7pyvuYalb9Ndf9p+AZ2fcPzLgaoKiVJUCtzXp93pAV8+JgH03UfL1/CzyWG2H9DHN5HVoGz20TRbBXV20N0ZzCgfMhqYD3ndGajSE4GvwHQHHHNg5RQWXBGtr1kaOUmzoCMKXYlq5TStoux2/TUsrVygXTA7TmczNHKJBubwtNZg5SIW6mB+YZDLDBDIdKcxqVwmNei/jZ5QhdxAoZgCDbJyC/bPJqUOk8ktZAb33uscErmJBHJ5YVUMchsDan2LgOrkNjr1GoaHZpAbGdCPF+OXQm6kWLAvvvdyK/3vmdygDc1cW+wstA1NdgubeCpcGvxSJcFxVMF1pY5K/F1JHQ5+UCFRO4dLTZn6L/dClniFgy/ea+ZeLVYoXt93xad59jMUUYjW9/RMPmVYiSjo5OWRjtQX67M2hiwIL9c/2DNhfP6o1SpHFeL1/fHZPD32qYsq+JsImXm6PDBJBN90b0mM6Xl+zj50sT34izgV/4izYx2AQRCKok1cmrjaLsb//80uJIywnLQTU42I8N71jSj3Uq/Q+X9mPqI7q7Ss1rUyVeXsvyOaZ0fUOIfMf/XtMyMabUG6xjljtWXq4AvwFPFD9mXqL5pvFb7Z+XbtB44fmdeDhj6XLVx4cemoxS+X79yAaAvFTaC2sdyIa5TAYYjGORpIcaSmoaDGmhzMarSs4bjG+/qB4v8nlm+UTRINjmkusifqBtNUIxmTpYNvupekCevBOuVO5KKBQb7sAd/CjVFAHQAAd5NK8vpcWa0AAAAASUVORK5CYII=)
      no-repeat center center;
    background-size: 100% 100%;
  }
  &-save {
    width: ptrd(280px);
    height: ptrd(80px);
    font-size: ptrd(32px);
    font-weight: bold;
    line-height: 1.2;
    padding-top: ptrd(20px);
    box-sizing: border-box;
    background: #ffffff;
    border-radius: ptrd(80px);
    color: #111e36;
  }
}
</style>